import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, DoCheck, HostListener, Inject, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';

import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DialogComponent } from './common/components/dialog/dialog.component';
import { SeedReturnAddProductSliderModelService } from './common/components/seed-return-add-product/seed-return-product-slider-model.service';
import { MasterConstants } from './common/constants/master-constants';
import { LolLoggerService } from './common/shared/lol-logger.service';
import { DashboardFilter } from './models/DashboardFilter';
import { SliderModel, UserSecurityAccess } from './models/user-security-access.model';
import { BlanketAddProductSliderModelService } from './modules/blanket-order/add-product/blanket-add-product-slider-model.service';
import { UploadAddProductSliderModelService } from './modules/blanket-order/upload-add-product/upload-add-product-slider-model.service';
import { CppReturnAddProductSliderModelService } from './common/components/cpp-return-add-product/cpp-return-product-slider-model.service';
import { CppCoiAddProductSliderModelService } from './modules/cpp-coi/cpp-coi-add-product/cpp-coi-add-product-slider-model.service';
import { ProductLineDeliveryInstructionSliderModelService } from './common/components/product-line-delivery-instructions/product-line-delivery-instructions-slider-model.service';
import { ContainerReturnsAddProductSliderModelService } from './modules/container-returns/container-returns-add-product/container-returns-add-product-slider-model.service';
import { SeedFulfillmentViewEditBreakdownSliderModelService } from './common/components/seed-fulfillment-breakdown-view-edit/seed-fulfillment-breakdown-view-edit-slider-model.service';
import { CppSRACostSheetGlossarySliderModelService } from './modules/cpp-sra-cost-sheet/cpp-sra-cost-sheet-glossary/cpp-sra-cost-sheet-glossary-slider-model.service';
import { EaAddProductSliderModelService } from './modules/seed/order/ea-order/ea-add-product/ea-add-product-slider-model.service';
import { EaProductModifyDecreaseUnitSliderModelService } from './modules/seed/order/ea-order/ea-product-modify-decrease-unit/ea-product-modify-decrease-unit-slider-model.service';
import { EaSwapProductSliderModelService } from './modules/seed/order/ea-order/ea-swap-product/ea-swap-product-slider-model.service';
import { SeedCropLossAddProductSliderModelService } from './modules/seed/seed-crop-loss/seed-crop-loss-add-product/seed-crop-loss-add-product-slider-model.service';
import { SeedReplantAddOriginalProductSliderModelService } from './modules/seed/seed-replant/seed-replant-add-original-product/seed-replant-add-original-product-slider-model.service';
import { SeedReplantAddReplantProductSliderModelService } from './modules/seed/seed-replant/seed-replant-add-replant-product/seed-replant-add-replant-product-slider-model.service';
import { StockTransferAddProductSliderModelService } from './modules/seed/sot/sot-add-product/sot-add-product.component-slider-model.service';
import { StockRequestHistorySliderModelService } from './modules/seed/sot/sot-request-history/sot-request-history.component-slider-model.service';
import { StockTransferSelectAccountSliderModelService } from './modules/seed/sot/sot-select-account/sot-select-account.component-slider-model.service';
import { AuthenticationService } from './services/common/authentication.service';
import { CommonService } from './services/common/common.service';
import { UserSecurityService } from './services/common/user-security.service';
import { CppPriceListService } from './services/cpp/cpp-price-list.service';
import { BroadcastService } from './services/infrastructure/broadcaster.service';
import { ConfigService } from './services/infrastructure/config.service';
import { CookieService } from './services/infrastructure/cookie.service';
import { LoaderService } from './services/infrastructure/loader.service';
import { LocalStorageService } from './services/infrastructure/local-storage.service';
import { NetworkService } from './services/infrastructure/network.service';
import { UserReportFilterSliderService } from './common/components/user-report-filter/user-report-filter-slider.service';
import { SliderModelService } from './services/infrastructure/sliderModel.service';
import { DashboardService } from './services/seed/dashboard.service';
import { DealerService } from './services/seed/dealer.service';
import { CppAddProductSliderModelService } from './modules/cpp/cpp-common-components/cpp-add-product/cpp-add-product-slider-model.service';
import { AddUpdateLicenseSliderModelService } from './modules/seed/licensing/add-update-license/add-update-license-slider-model.service';
import { CropEdgeAccountListDialogComponent } from './modules/partnerwebsite/crop-edge-account-dialog/crop-edge-account-dialog.component';
import { OtiOrderDetailSliderModelService } from './modules/oti/oti-order-detail/oti-order-detail-slider-model.service';
import { CppSraAddProductSliderModelService } from './modules/cpp/sra-orders/cpp-sra-add-product/cpp-sra-add-product-slider-model.service';
import { PlotSeedReleaseBreakdownViewSliderModelService } from './modules/seed/plot-seed/plot-seed-release-breakdown-view/plot-seed-release-breakdown-view-slider-model.service';
import { SFChatService } from './services/sfchat/sfchat.service';
import { TooltipScrollCloseInitializer } from './common/directive/tooltip-scroll-close/ngb-tooltip-scroll-close.directive';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, DoCheck, OnDestroy {
  private subscription = new Array<Subscription>();

  cropYear: any;
  company: any;
  selectedCompany: any = MasterConstants.US_COMPANYCODE;
  environmentApply: any;
  selectedYear: any;
  dashboardFilter: DashboardFilter;
  showLoader = false;
  showLogout = false;
  showCompanyYear = false;
  isCompanyYearVisible = false;
  isUserGreetingsVisible = false;
  showUserProfile = false;
  isSelected = false;
  iFrameURL: any = null;

  isHeaderServiceCall = false;
  validateEvolveData: any;
  userId: any;
  userIdRole: any;
  userAccess = true;
  isSignOut = false;
  baseTab = '';
  activeTabMobile = '';
  showHidebackDrop = false;
  firstName = '';
  lastName = '';

  isPageLoad: boolean = false;
  isEmulated: boolean = false;

  //user access class
  userSecurityAccess: UserSecurityAccess = new UserSecurityAccess();
  sliderModel: SliderModel = new SliderModel();

  emulatedUserId = '';
  emulationChangeSubscription: any;
  hideShowCOISubscription: any;
  isFromEmualtionPage = false;
  @ViewChild('sidenav') sidenav: MatSidenav;

  userMenuAccessList: any;
  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
  cppPriceAccounts: any = [];
  public partnerURLs: any;
  selectedAccountId: any = 0;
  isRedirectPage = false;
  resetUrlPath = false;
  configPath = '';

  isPopupOpen = false;
  //chatAccess = false;
  //chatPOC = '';
  //chatBusNo = '';
  //chatUrl = '';
  modalStyle: { [key: string]: string } = { width: '600px', height: '540px' };
  isResized = false;
  homePageURL = '/cc/landing-data';
  sraOrderAccess: any;
  sraApproversAccess: any;
  showChatbot = false;

  constructor(public http: HttpClient,
    @Inject('BASE_URL') public baseUrl: string,
    private authenticationSerivce: AuthenticationService,
    private dashboard: DashboardService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private loaderService: LoaderService,
    private sliderModelService: SliderModelService,
    private cookieService: CookieService,
    private commonService: CommonService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private userSecurityService: UserSecurityService,
    public dialog: MatDialog,
    private cppAddProductSliderModelService: CppAddProductSliderModelService,
    private addUpdateLicenseSliderModelService: AddUpdateLicenseSliderModelService,
    private cppPriceListService: CppPriceListService,
    private dealerservice: DealerService,
    private matDialog: MatDialog,
    private seedReturnAddProductSliderModelService: SeedReturnAddProductSliderModelService,
    private blanketAddProductSliderModelService: BlanketAddProductSliderModelService,
    private uploadAddProductSliderModelService: UploadAddProductSliderModelService,
    private cppReturnAddProductSliderModelService: CppReturnAddProductSliderModelService,
    private cppCoiAddProductSliderModelService: CppCoiAddProductSliderModelService,
    private stockTransferAddProductSliderModelService: StockTransferAddProductSliderModelService,
    private stockRequestHistorySliderModelService: StockRequestHistorySliderModelService,
    private seedReplantAddOriginalProductSliderModelService: SeedReplantAddOriginalProductSliderModelService,
    private seedReplantAddReplantProductSliderModelService: SeedReplantAddReplantProductSliderModelService,
    private seedCropLossAddProductSliderModelService: SeedCropLossAddProductSliderModelService,
    private stockTransferSelectAccountSliderModelService: StockTransferSelectAccountSliderModelService,
    private otiOrderDetailSliderModelService: OtiOrderDetailSliderModelService,
    private productLineDeliveryInstructionSliderModelService: ProductLineDeliveryInstructionSliderModelService,
    private containerReturnsAddProductSliderModelService: ContainerReturnsAddProductSliderModelService,
    private seedFulfillmentViewEditBreakdownSliderModelService: SeedFulfillmentViewEditBreakdownSliderModelService,
    private plotSeedReleaseBreakdownViewSliderModelService: PlotSeedReleaseBreakdownViewSliderModelService,
    private cppSRACostSheetGlossarySliderModelService: CppSRACostSheetGlossarySliderModelService,
    private networkService: NetworkService,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private userReportFilterSliderService: UserReportFilterSliderService,
    private eaSwapProductSliderModelService: EaSwapProductSliderModelService,
    private eaAddProductSliderModelService: EaAddProductSliderModelService,
    private eaProductModifyDecreaseUnitSliderModelService: EaProductModifyDecreaseUnitSliderModelService,
    private cppSraAddProductSliderModelService: CppSraAddProductSliderModelService,
    private chatService: SFChatService,
    private zone: NgZone,
    _tooltipScrollCloseInitializer: TooltipScrollCloseInitializer
  ) {
    if (this.localStorageService.get(MasterConstants.IS_RELOAD) == 'true') {
      this.isHeaderServiceCall = true;
      this.router.navigate(['/']);
    }

    this.localStorageService.set(MasterConstants.IS_RELOAD, false);
    this.localStorageService.set(MasterConstants.EVOLVE_ACCESS, null);
    this.localStorageService.set(MasterConstants.IS_LOGOUT, false);
    this.localStorageService.set(MasterConstants.ORDER_TAB_INDEX, 0);
  }

  title = 'ClientApp';

  @HostListener('window:click', ['$event']) onClick() {
    this.isSelected = false;
  }

  menuToggle($event) {
    $event.stopPropagation();
    this.isSelected = !this.isSelected;
  }

  toggleChatbot(): void {
    this.showChatbot = !this.showChatbot;
  }

  setUserLoginAnalytics(userAccessDetails) {
    this.subscription.push(this.userSecurityService.getGetLoginAccountId().subscribe(loginId => {
      var eventData = {
        'event': 'login',
        'user': {
          'userId': userAccessDetails.userId,
          'userType': userAccessDetails.userIdRole,
          'loginAccountID': loginId
        }
      };
      this.commonService.setDataLayerAnalytics(eventData);
    }));
  }

  expand() {
    this.isResized = !this.isResized;
  }

  onFocus(event: any): void {
    let isSelectedCom;
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
        isSelectedCom = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
      }

      if (this.validateEvolveData !== null) {
        const isEmulationUserData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode != this.selectedCompany && x.isEmulationSet == true);
        if (isEmulationUserData && isEmulationUserData.isEmulationSet && this.selectedYear != undefined
          && this.selectedCompany != undefined && isSelectedCom != this.selectedCompany) {
          return;
        }

        const selectedUser = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany);
        if (this.selectedYear != undefined && this.selectedCompany != undefined && isSelectedCom != this.selectedCompany) {
          this.updateCurrentSession(this.selectedYear, this.selectedCompany);
          this.localStorageService.set(MasterConstants.HEADER_COMPANY_CODE, JSON.stringify(this.selectedCompany));
          this.localStorageService.set(MasterConstants.HEADER_CROP_YEAR, JSON.stringify(this.selectedYear));
          this.enableDisableMenu();
          this.hideShowCOI();
        }

        if (selectedUser && selectedUser.isEmulationSet) {
          // Enable emulated User on Screen
          this.isEmulated = selectedUser.isEmulationSet;
          this.firstName = selectedUser.firstName;
          this.lastName = selectedUser.lastName;
          this.emulatedUserId = selectedUser.userId + ' [' + selectedUser.userIdRole + ']';
          this.enableDisableMenu();
          this.hideShowCOI();
        } else if (selectedUser && !selectedUser.isEmulationSet) {
          this.isEmulated = false;
          this.firstName = '';
          this.lastName = '';
          this.emulatedUserId = '';
          this.enableDisableMenu();
          this.hideShowCOI();
        }
      }
    }
  }

  ngAfterViewInit() {
    this.sliderModelService.SetSideNav(this.sidenav);
    this.cppAddProductSliderModelService.SetCppSideNav(this.sidenav);
    this.cppSraAddProductSliderModelService.SetCppSraSideNav(this.sidenav);
    this.blanketAddProductSliderModelService.SetBlanketSideNav(this.sidenav);
    this.uploadAddProductSliderModelService.SetBlanketSideNav(this.sidenav);
    this.addUpdateLicenseSliderModelService.SetLicenseSideNav(this.sidenav);
    this.seedReturnAddProductSliderModelService.setSeedReturnSideNav(this.sidenav);
    this.cppReturnAddProductSliderModelService.setCppReturnSideNav(this.sidenav);
    this.cppCoiAddProductSliderModelService.setCppCoiSideNav(this.sidenav);
    this.stockTransferAddProductSliderModelService.setStockTransferSideNav(this.sidenav);
    this.stockRequestHistorySliderModelService.setStockTransferSideNav(this.sidenav);
    this.seedReplantAddOriginalProductSliderModelService.setSideNav(this.sidenav);
    this.seedReplantAddReplantProductSliderModelService.setSideNav(this.sidenav);
    this.seedCropLossAddProductSliderModelService.setSideNav(this.sidenav);
    this.stockTransferSelectAccountSliderModelService.setStockTransferSideNav(this.sidenav);
    this.otiOrderDetailSliderModelService.setotiOrderDetailSideNav(this.sidenav);
    this.productLineDeliveryInstructionSliderModelService.setProductLineDeliveryInstructionSideNav(this.sidenav);
    this.containerReturnsAddProductSliderModelService.setSideNav(this.sidenav);
    this.seedFulfillmentViewEditBreakdownSliderModelService.setSeedFulfillmentBreakdownSideNav(this.sidenav);
    this.plotSeedReleaseBreakdownViewSliderModelService.setplotSeedReleaseBreakdownViewSideNav(this.sidenav);
    this.cppSRACostSheetGlossarySliderModelService.setSideNav(this.sidenav);
    this.eaSwapProductSliderModelService.setSideNav(this.sidenav);
    this.eaAddProductSliderModelService.setSideNav(this.sidenav);
    this.eaProductModifyDecreaseUnitSliderModelService.setSideNav(this.sidenav);
    if (this.resetUrlPath) {
      this.localStorageService.remove('url-path');
    }
    this.userReportFilterSliderService.setUserFilterSideNav(this.sidenav);
  }

  ngDoCheck() {
    var islocalStorageComCode;
    if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
      islocalStorageComCode = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
    }

    if (this.selectedCompany != undefined && this.selectedYear != undefined && this.isHeaderServiceCall) {
      this.isHeaderServiceCall = false;
      this.localStorageService.set(MasterConstants.HEADER_CROP_YEAR, JSON.stringify(this.selectedYear));
      this.localStorageService.set(MasterConstants.HEADER_COMPANY_CODE, JSON.stringify(this.selectedCompany));
    }
    else if (this.selectedCompany != undefined && islocalStorageComCode != undefined && this.selectedCompany != islocalStorageComCode) {
      this.localStorageService.set(MasterConstants.HEADER_CROP_YEAR, JSON.stringify(this.selectedYear));
      this.localStorageService.set(MasterConstants.HEADER_COMPANY_CODE, JSON.stringify(this.selectedCompany));
    }
  }

  onClose() {
    if (this.sliderModelService.newGrowerOrderSliderClose.value) {
      this.sliderModelService.GrowerSearchSliderActive.next(false);
      this.sliderModelService.newGrowerOrderSliderClose.next(false);
    } else if (this.sliderModelService.getNewCommentDlgValue()) {
      this.sliderModelService.sliderCloseRqt.next(true);
      return;
    }
    else {
      this.sliderModelService.sliderCloseRqt.next(true);
      this.sliderModelService.close();
    }

    this.cppAddProductSliderModelService.cppSliderCloseRqt.next(true);
    this.cppAddProductSliderModelService.cppClose();

    this.cppSraAddProductSliderModelService.CppSraSliderCloseRqt.next(true);
    this.cppSraAddProductSliderModelService.CppSraClose();

    this.addUpdateLicenseSliderModelService.addUpdateLicenseSliderCloseRqt.next(true);
    this.addUpdateLicenseSliderModelService.licenseClose();

    this.seedReturnAddProductSliderModelService.seedReturnSliderCloseRqt.next(true);
    this.seedReturnAddProductSliderModelService.seedReturnClose();

    this.userReportFilterSliderService.userFilterClose();

    this.blanketAddProductSliderModelService.BlanketSliderCloseRqt.next(true);
    this.blanketAddProductSliderModelService.BlanketClose();

    this.uploadAddProductSliderModelService.uploadAddSliderCloseRqt.next(true);
    this.uploadAddProductSliderModelService.BlanketClose();

    this.cppReturnAddProductSliderModelService.cppReturnSliderCloseRqt.next(true);
    this.cppReturnAddProductSliderModelService.cppReturnClose();

    this.cppCoiAddProductSliderModelService.cppCoiSliderCloseRqt.next(true);
    this.cppCoiAddProductSliderModelService.cppCoiClose();

    this.stockTransferAddProductSliderModelService.stockTransferSliderCloseRqt.next(true);
    this.stockTransferAddProductSliderModelService.stockTransferClose();

    this.stockRequestHistorySliderModelService.stockTransferSliderCloseRqt.next(true);
    this.stockRequestHistorySliderModelService.stockTransferClose();

    this.seedReplantAddOriginalProductSliderModelService.sliderCloseRqt.next(true);
    this.seedReplantAddOriginalProductSliderModelService.close();

    this.seedReplantAddReplantProductSliderModelService.sliderCloseRqt.next(true);
    this.seedReplantAddReplantProductSliderModelService.close();

    this.seedCropLossAddProductSliderModelService.sliderCloseRqt.next(true);
    this.seedCropLossAddProductSliderModelService.close();

    this.stockTransferSelectAccountSliderModelService.sotSelectAccountCloseRqt.next(true);
    this.stockTransferSelectAccountSliderModelService.stockTransferClose();

    this.otiOrderDetailSliderModelService.otiOrderDetailCloseRqt.next(true);
    this.otiOrderDetailSliderModelService.otiOrderDetailClose();

    this.productLineDeliveryInstructionSliderModelService.productLineDeliveryInstructionSliderCloseRqt.next(true);
    this.productLineDeliveryInstructionSliderModelService.productLineDeliveryInstructionClose();

    this.containerReturnsAddProductSliderModelService.sliderCloseRqt.next(true);
    this.containerReturnsAddProductSliderModelService.close();
    this.seedFulfillmentViewEditBreakdownSliderModelService.seedFulfillmentBreakdownSliderCloseRqt.next(true);
    this.seedFulfillmentViewEditBreakdownSliderModelService.seedFulfillmentBreakdownClose();
    this.plotSeedReleaseBreakdownViewSliderModelService.plotSeedReleaseBreakdownViewSliderCloseRqt.next(true);
    this.plotSeedReleaseBreakdownViewSliderModelService.plotSeedReleaseBreakdownViewClose();
    this.cppSRACostSheetGlossarySliderModelService.sliderCloseRqt.next(true);
    this.cppSRACostSheetGlossarySliderModelService.close();

    this.eaSwapProductSliderModelService.sliderCloseRqt.next(true);
    this.eaSwapProductSliderModelService.close();

    this.eaAddProductSliderModelService.sliderCloseRqt.next(true);
    this.eaAddProductSliderModelService.close();

    this.eaProductModifyDecreaseUnitSliderModelService.sliderCloseRqt.next(true);
    this.eaProductModifyDecreaseUnitSliderModelService.close();
  }

  ngOnInit(): void {
    //Set local storage for display console message
    if (this.localStorageService.get(MasterConstants.CONSOLE_MESSAGE) === null
      || this.localStorageService.get(MasterConstants.CONSOLE_MESSAGE) == undefined) {
      this.localStorageService.set(MasterConstants.CONSOLE_MESSAGE, 0);
    }

    //Set local storage for Token retry count
    var retryCount = this.localStorageService.get(MasterConstants.TOKEN_RETRY_COUNT);
    if (retryCount === null || retryCount == undefined) {
      this.localStorageService.set(MasterConstants.TOKEN_RETRY_COUNT, 0);
      retryCount = this.localStorageService.get(MasterConstants.TOKEN_RETRY_COUNT);
    }

    LolLoggerService.toConsole("location :" + location);

    let code = '';
    code = location.search.split('code=').pop();
    let urlRef = '';
    urlRef = location.search.split('ref=').pop();

    if (urlRef != undefined && urlRef.includes(MasterConstants.URL_REFERRER)) {
      urlRef = MasterConstants.URL_REFERRER;

    } else {
      urlRef = '';
    }
    this.localStorageService.set('urlRef', urlRef);

    if (!this.localStorageService.get('token') && !code) {
      this.doLogin(urlRef);
    }
    else if (code) {
      this.subscription.push(this.authenticationSerivce.getAuthToken(code, urlRef).subscribe(results => {
        if (results && results.message == "Token Expired") {
          if (this.localStorageService.get(MasterConstants.TOKEN_RETRY_COUNT) == 0) {
            this.doLogin(urlRef);
          }
          else if (this.localStorageService.get(MasterConstants.TOKEN_RETRY_COUNT) > 0) {
            this.loaderService.setLoaderStatus(false);
            this.isPageLoad = false;
            this.router.navigate(['/unauthorize']);
          }
        }
        else if (results) {
          this.localStorageService.set('token', results.access_token);
          this.localStorageService.set('refreshToken', results.refresh_token);
          this.localStorageService.set('tokenExpiry', results.expires_in);
          this.localStorageService.set('loggedInTimeSecond', Math.floor(new Date().getTime() / 1000));
          this.DoNext();
        }
        else {
          if (this.localStorageService.get(MasterConstants.TOKEN_RETRY_COUNT) > 0) {
            this.loaderService.setLoaderStatus(false);
            this.isPageLoad = false;
            this.router.navigate(['/unauthorize']);
          }
          else if (this.localStorageService.get(MasterConstants.TOKEN_RETRY_COUNT) == 0) {
            this.doLogin(urlRef);
          }
        }
      }, (error => {
        this.loaderService.setLoaderStatus(false);
        LolLoggerService.error(error);
        this.isPageLoad = true;
      })));
    }
    else if (this.localStorageService.get('token')) {
      if (this.IsTokenExpired()) {
        this.loaderService.setLoaderStatus(true);
        let refreshToken: string = localStorage.getItem('refreshToken');
        this.subscription.push(this.authenticationSerivce.getAuthTokenByRefreshToken(refreshToken).subscribe(results => {
          if (results && results.message == "Token Expired") {
            this.loaderService.setLoaderStatus(false);
            this.ClearToken();
          }
          else if (results) {
            this.localStorageService.set('token', results.access_token);
            this.localStorageService.set('refreshToken', results.refresh_token);
            this.localStorageService.set('tokenExpiry', results.expires_in);
            this.localStorageService.set('loggedInTimeSecond', Math.floor(new Date().getTime() / 1000));
            this.DoNext();
          }
          else {
            this.doLogin(urlRef);
          }
        }, (error => {
          this.loaderService.setLoaderStatus(false);
          this.ClearToken();
        })));
      }
      else {
        this.DoNext();
      }
    }
  }

  private doLogin(urlRef) {

    this.subscription.push(this.authenticationSerivce.getOAuthSettings(urlRef).subscribe(response => {
      if (response) {
        const path = this.localStorageService.get('url-path');
        const currentRetryCount = this.localStorageService.get(MasterConstants.TOKEN_RETRY_COUNT);
        this.localStorageService.clear();

        if (currentRetryCount === 0) {
          this.localStorageService.set(MasterConstants.TOKEN_RETRY_COUNT, 1);
        } else if (currentRetryCount === null || currentRetryCount == undefined) {
          this.localStorageService.set(MasterConstants.TOKEN_RETRY_COUNT, 0);
        }

        if (path && path.indexOf("unauthorize") === -1) {
          localStorage.setItem('url-path', path);
        }

        var url = response.oAuthURL + '?client_id=' + response.clientId + '&response_type=code&redirect_uri=' + response.redirectURI;


        window.location.href = encodeURI(url);
      }
    }, (error => {
      this.loaderService.setLoaderStatus(false);
      LolLoggerService.info('Failed To Get OAuthSettings');
      LolLoggerService.error(error);
      this.isPageLoad = false;
    })));
  }

  private DoNext() {
    this.SaveloginTime();
    this.subscribeModel();
    this.broadCastCall();

    this.isFromEmualtionPage = false;
    this.isRedirectPage = false;
    this.dashboardFilter = new DashboardFilter();

    // Set the default value
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.selectedYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.selectedCompany = MasterConstants.US_COMPANYCODE;

    if (this.localStorageService.get(MasterConstants.ENVIRONMENT)) {
      this.environmentApply = this.localStorageService.get(MasterConstants.ENVIRONMENT);
    }

    // Validate the evolve access
    if (this.validateEvolveData == undefined) {
      this.validateEvolveAccess();
    }
    else if ((this.validateEvolveData.resultData[0] != undefined && this.validateEvolveData.resultData[0].isSetAccount == true) ||
      (this.validateEvolveData.resultData[0] != undefined && this.validateEvolveData.resultData[0].evolveAccountRestriction == true && this.validateEvolveData.resultData[0].evolveSiteAccess == true)) {
      // Load master data
      if (this.validateEvolveData.resultData[0].isEmulationSet) {
        this.userId = this.validateEvolveData.resultData[0].loggedUserId;
        this.firstName = this.validateEvolveData.resultData[0].firstName;
        this.lastName = this.validateEvolveData.resultData[0].lastName;
        this.isEmulated = true;
        this.emulatedUserId = this.validateEvolveData.resultData[0].userId + ' [' + this.validateEvolveData.resultData[0].userIdRole + ']';
      }
      else {
        this.userId = this.validateEvolveData.resultData[0].userId;
        this.firstName = this.validateEvolveData.resultData[0].firstName;
        this.lastName = this.validateEvolveData.resultData[0].lastName;
        this.isEmulated = false;
        this.emulatedUserId = '';
      }
      this.loadMasterData();
      this.loadYearDropDown();
      this.loadCompanyDropDown();
      this.isPageLoad = true;
    }
    else if (this.validateEvolveData.resultData[0] != undefined && this.validateEvolveData.resultData[0].evolveAccountRestriction == false
      && this.validateEvolveData.resultData[0].evolveSiteAccess == true && this.validateEvolveData.resultData[0].isSetAccount == false) {
      // Load master data
      if (this.validateEvolveData.resultData[0].isEmulationSet) {
        this.userId = this.validateEvolveData.resultData[0].loggedUserId;
        this.firstName = this.validateEvolveData.resultData[0].firstName;
        this.lastName = this.validateEvolveData.resultData[0].lastName;
        this.isEmulated = true;
        this.emulatedUserId = this.validateEvolveData.resultData[0].userId + ' [' + this.validateEvolveData.resultData[0].userIdRole + ']';
      }
      else {
        this.userId = this.validateEvolveData.resultData[0].userId;
        this.firstName = this.validateEvolveData.resultData[0].firstName;
        this.lastName = this.validateEvolveData.resultData[0].lastName;
        this.isEmulated = false;
        this.emulatedUserId = '';
      }
      this.loadMasterData();
      this.loadYearDropDown();
      this.loadCompanyDropDown();
      this.isPageLoad = true;
      // this.router.navigate(['/account']);
    }
    if (this.validateEvolveData != undefined) {
      this.chatService.initialize(this.validateEvolveData.resultData[0]);
    }

    this.router.events.subscribe((e: any) => {
      this.SaveloginTime();
      // set tab menu class active on NavigationEnd event
      if (e instanceof NavigationEnd) {
        const url = e.url;
        this.configPath = url;
        const baseURL = url.split('/');
        //redirect to swagger page for /swagger/index.html
        if (url.indexOf('swagger') === -1) {
          this.activeTabMobile = baseURL[1];
          const baseTabList: { [key: string]: string; } = {
            '': 'oti',
            'oti': 'oti',
            'order': 'oti-order',
            'audit': 'seed',
            'reports': 'seed',
            'seed-fulfillment': 'seed',
            'release-items-audit': 'seed',
            'licenses': 'seed',
            'landing-data': 'seed',
            'orders': 'seed',
            'seed-returns-soybean-dashboard': 'seed',
            'seed-returns-dashboard': 'seed',
            'seed-replant-landing': 'seed',
            'sot-landing': 'seed',
            'crop-loss-landing': 'seed',
            'delivery-instructions': 'seed',
            'account': 'account',
            'emulation': 'emulation',
            'prepay': 'prepay',
            'cpp': 'cpp',
            'container-returns': 'cpp',
            'cpp-returns': 'cpp',
            'forecast': 'cpp',
            'subscription-landing-page': '',
            'seed-grower-program': 'programs',
            'grower-program': 'programs',
            'sot-request-entry': 'seed',
            'sot-request-review': 'seed',
            'seed-reservation-landing': 'seed',
            'associate-crop-landing': 'seed',
            'seed-reservation': 'seed',
            'associate-crop': 'seed',
            'plot-seed-landing': 'seed',
            'plot-seed': 'seed',
            'pricelistLookup': 'pricelistLookup',
            'associate-crop-reconciliation-landing': 'seed',
            'associate-crop-inventory': 'seed',
            'proving-ground-seed-landing': 'seed',
            'proving-ground-seed': 'seed'
          };
          if (baseURL[1] || baseURL[1] == '') {
            this.baseTab = baseTabList[baseURL[1]] || '';
          }
        }
      }
    });

    this.subscription.push(this.dashboard.isBackDropVisible.subscribe((data) => {
      this.showHidebackDrop = data;
    }));

    this.subscription.push(this.loaderService.showLoader.subscribe((status: boolean) => {
      setTimeout(x => { this.showLoader = status; }, 0);
    }));

    this.CheckLoggedOut();
    this.getPartnerWebsiteData();
    let path = localStorage.getItem('url-path');
    if ((path === undefined || path === null) && location.pathname.indexOf('cc/landing-data') === -1) {
      path = location.pathname;
      localStorage.setItem('url-path', path);
    }
    if (path) {
      this.resetUrlPath = true;
      this.router.navigateByUrl(path);
    } else {
      this.resetUrlPath = false;
      this.router.navigateByUrl('/cc/landing-data');
    }
    //this.subscription.push(this.userSecurityService.getChatAccess().subscribe(results => {
    //  this.chatAccess = results.isChatActive;
    //  this.chatPOC = results.chatPOC;
    //  this.chatBusNo = results.chatBusNo;
    //  this.chatUrl = results.chatURL;
    //}));
  }

  broadCastCall() {
    this.emulationChangeSubscription = this.broadcastService.on<any>(this.configService.SET_CLEAR_EMULATION).subscribe((data) => {
      this.isFromEmualtionPage = true;
      this.isRedirectPage = true;
      this.validateEvolveAccess();
      this.getPartnerWebsiteData();
    });

    this.broadcastService.on<any>(this.configService.SRO_ACCESS).subscribe((data) => {
      this.subscription.push(this.userSecurityService.checkSraAccountAccess().subscribe((result: any) => {
        if (result == true) {
          this.userSecurityAccess.isSRAOrderAccess = true;
          this.userSecurityAccess.isCPPtabAccess = true;
          this.userSecurityAccess.isSraApproversAccess = true;
        } else {
          this.userSecurityAccess.isSRAOrderAccess = false;
          // Manage the CPP Menu
          if (this.userSecurityAccess.isCPPOrderAccess || this.userSecurityAccess.isCPPErrorAccess || this.userSecurityAccess.isCPPPriceListAccess
            || this.userSecurityAccess.isCPPReturnsAccess || this.userSecurityAccess.isCPPReportAccess || this.userSecurityAccess.isSRAOrderAccess || this.userSecurityAccess.isSraApproversAccess || this.userSecurityAccess.isCPPUserListAccess) {
            this.userSecurityAccess.isCPPtabAccess = true;
          }
        }
      }, error => LolLoggerService.error(error)));
    });

    this.broadcastService.on<any>(this.configService.SRO_APROVERS_ACCESS).subscribe((data) => {
      this.subscription.push(this.userSecurityService.checkSraApproversAccess().subscribe((result: any) => {
        if (result == true) {
          this.userSecurityAccess.isCPPtabAccess = true;
          this.userSecurityAccess.isSraApproversAccess = true;
        } else {
          this.userSecurityAccess.isSraApproversAccess = false;
          // Manage the CPP Menu
          if (this.userSecurityAccess.isCPPOrderAccess || this.userSecurityAccess.isCPPErrorAccess || this.userSecurityAccess.isCPPPriceListAccess
            || this.userSecurityAccess.isCPPReturnsAccess || this.userSecurityAccess.isCPPReportAccess || this.userSecurityAccess.isSRAOrderAccess || this.userSecurityAccess.isSraApproversAccess || this.userSecurityAccess.isCPPUserListAccess) {
            this.userSecurityAccess.isCPPtabAccess = true;
          }
        }
      }, error => LolLoggerService.error(error)));
    });


    this.broadcastService.on<any>(this.configService.EDLP_ACCESS).subscribe((data) => {
      this.subscription.push(this.userSecurityService.checkEdlpAccess().subscribe((result: any) => {
        if (result == true) {
          this.userSecurityAccess.isCPPtabAccess = true;
          this.userSecurityAccess.isCPPReportAccess = true;
          this.userSecurityAccess.isEDLPAccess = true;
        } else {
          this.userSecurityAccess.isEDLPAccess = false;
          if (this.userSecurityAccess.isCPPOrderAccess || this.userSecurityAccess.isCPPErrorAccess || this.userSecurityAccess.isCPPPriceListAccess
            || this.userSecurityAccess.isCPPReturnsAccess || this.userSecurityAccess.isCPPReportAccess || this.userSecurityAccess.isSRAOrderAccess || this.userSecurityAccess.isSraApproversAccess || this.userSecurityAccess.isCPPUserListAccess) {
            this.userSecurityAccess.isCPPtabAccess = true;
          }

          if (this.userSecurityAccess.isSRAAccess || this.userSecurityAccess.isCPPPriceListAccess || this.userSecurityAccess.isEDLPAccess) {
            this.userSecurityAccess.isCPPReportAccess = true;
          }
        }
      }, error => LolLoggerService.error(error)));
    });

    this.subscription.push(this.broadcastService.on<any>(this.configService.IS_AUTHORIZE).subscribe((data) => {
      if (data.isAuthorize == false) {
        this.userAccess = false;
      }
    }));

    this.subscription.push(this.broadcastService.on<any>(this.configService.HIDE_SHOW_COI_MENU).subscribe((data) => {
      if (data.checkHideShow == true) {
        this.hideShowCOI();
      }
    }));

    this.subscription.push(this.broadcastService.on<any>(this.configService.ACCESS_TYPE).subscribe((data) => {
      if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)
        && data.accessType) {
        this.enableDisableMenu();
        this.hideShowCOI();
      }
    }));
  }

  subscribeModel() {
    this.subscription.push(this.cppAddProductSliderModelService.addCppProductSlider.subscribe(x => {
      this.sliderModel.appCppProductAdd = x;
    }));
    this.subscription.push(this.cppSraAddProductSliderModelService.addCppSraProductSlider.subscribe(x => {
      this.sliderModel.appCppSraProductAdd = x;
    }));

    this.subscription.push(this.blanketAddProductSliderModelService.addBlanketProductSlider.subscribe(x => {
      this.sliderModel.appBlanketProductAdd = x;
    }));

    this.subscription.push(this.uploadAddProductSliderModelService.uploadAddProductSlider.subscribe(x => {
      this.sliderModel.appBlanketProductUploadAdd = x;
    }));

    this.subscription.push(this.seedReturnAddProductSliderModelService.addSeedReturnProductSlider.subscribe(x => {
      this.sliderModel.appSeedReturnProductAdd = x;
    }));

    this.subscription.push(this.cppReturnAddProductSliderModelService.addcppReturnProductSlider.subscribe(x => {
      this.sliderModel.appCppReturnProductAdd = x;
    }));
    this.subscription.push(this.userReportFilterSliderService.userReportFilterSlider.subscribe(x => {
      this.sliderModel.appUserReportFilter = x;
    }));

    this.subscription.push(this.cppReturnAddProductSliderModelService.addcppReturnProductSlider.subscribe(x => {
      this.sliderModel.appCppReturnProductAdd = x;
    }));

    this.subscription.push(this.addUpdateLicenseSliderModelService.addUpdateLicenseSlider.subscribe(x => {
      this.sliderModel.appUpdateLicense = x;
    }));

    this.subscription.push(this.cppCoiAddProductSliderModelService.addCoiAddProductSlider.subscribe(x => {
      this.sliderModel.appCppCoiAdd = x;
    }));

    this.subscription.push(this.stockTransferAddProductSliderModelService.addStockTransferAddProductSlider.subscribe(x => {
      this.sliderModel.appStockTransferAdd = x;
    }));

    this.subscription.push(this.stockRequestHistorySliderModelService.addStockTransferRequestHistorySlider.subscribe(x => {
      this.sliderModel.appStockTransferRequestHistory = x;
    }));

    this.subscription.push(this.seedReplantAddOriginalProductSliderModelService.addProductSlider.subscribe(x => {
      this.sliderModel.appSeedReplantOriginalProductAdd = x;
    }));

    this.subscription.push(this.seedReplantAddReplantProductSliderModelService.addProductSlider.subscribe(x => {
      this.sliderModel.appSeedReplantProductAdd = x;
    }));

    this.subscription.push(this.seedCropLossAddProductSliderModelService.addProductSlider.subscribe(x => {
      this.sliderModel.appSeedCropLossProductAdd = x;
    }));

    this.subscription.push(this.stockTransferSelectAccountSliderModelService.sotSelectAccountSlider.subscribe(x => {
      this.sliderModel.appStockTransferAccountAdd = x;
    }));

    this.subscription.push(this.otiOrderDetailSliderModelService.otiOrderDetailSlider.subscribe(x => {
      this.sliderModel.otiOrderDetailSlider = x;
    }));

    this.subscription.push(this.containerReturnsAddProductSliderModelService.addProductSlider.subscribe(x => {
      this.sliderModel.appcontainerReturnsProductAdd = x;
    }));

    this.subscription.push(this.productLineDeliveryInstructionSliderModelService.addProductLineDeliveryInstructionSlider.subscribe(x => {
      this.sliderModel.appProductLineDeliveryInstructionAdd = x;
    }));

    this.subscription.push(this.seedFulfillmentViewEditBreakdownSliderModelService.seedFulfillmentBreakdownSlider.subscribe(x => {
      this.sliderModel.appSeedFulfillmentBreakdownViewEdit = x;
    }));

    this.subscription.push(this.plotSeedReleaseBreakdownViewSliderModelService.plotSeedReleaseBreakdownViewSlider.subscribe(x => {
      this.sliderModel.appPlotSeedReleaseBreakdownView = x;
    }));

    this.subscription.push(this.cppSRACostSheetGlossarySliderModelService.addProductSlider.subscribe(x => {
      this.sliderModel.showSRACostSheetGlossary = x;
    }));

    this.subscription.push(this.eaSwapProductSliderModelService.eaSwapProductSlider.subscribe(x => {
      this.sliderModel.eaSwapProductAdd = x;
    }));

    this.subscription.push(this.eaAddProductSliderModelService.eaAddProductSlider.subscribe(x => {
      this.sliderModel.eaAddProductUnit = x;
    }));

    this.subscription.push(this.eaProductModifyDecreaseUnitSliderModelService.eaProductModifyDecreaseSlider.subscribe(x => {
      this.sliderModel.eaProductModifyDecreaseUnit = x;
    }));

    this.subscription.push(this.sliderModelService.addProductSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.appProductAdd = x;
    }));

    this.subscription.push(this.sliderModelService.changeProductSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.appProductChange = x;
    }));

    this.subscription.push(this.sliderModelService.orderTransferSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.appOrderTransfer = x;
    }));

    this.subscription.push(this.sliderModelService.diffDealerGrowerOrderTransferSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.appdiffDealerGrowerOrderTransfer = x;
    }));

    this.subscription.push(this.sliderModelService.dealerOrderTransferSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.appDealerOrderTransfer = x;
    }));

    this.subscription.push(this.sliderModelService.growerSearchTransferSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.appGrowerSearch = x;
    }));

    this.subscription.push(this.sliderModelService.itemAvailabilityDetailSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.appItemAvailabilityDetail = x;
    }));

    this.subscription.push(this.sliderModelService.dealerOrderInternalTransferSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.appDealerOrderInternalTransfer = x;
    }));

    this.subscription.push(this.sliderModelService.growerProgramBudgetSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.growerProgramBudgetSlider = x;
    }));

    this.subscription.push(this.sliderModelService.retailerSearchTransferSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.appRetailerSearch = x;
    }));

    this.subscription.push(this.sliderModelService.growerProgramNameSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.growerProgramNameSlider = x;
    }));

    this.subscription.push(this.sliderModelService.growerProgramCommentSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.growerProgramCommentSlider = x;
    }));

    this.subscription.push(this.sliderModelService.reconcileVarietySlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.reconcileVarietySlider = x;
    }));

    this.subscription.push(this.sliderModelService.sraRequestDetailsSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.sraRequestDetailsSlider = x;
    }));

    this.subscription.push(this.sliderModelService.sraRequestDetailsSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.sraRequestDetailsSlider = x;
    }));

    this.subscription.push(this.sliderModelService.seedReservationReconcileAddSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.seedReservationReconcileAddSlider = x;
    }));

    this.subscription.push(this.sliderModelService.seedReservationReconcileAddHybridSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.seedReservationReconcileAddHybridSlider = x;
    }));

    this.subscription.push(this.sliderModelService.sraRequestDetailsSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.sraRequestDetailsSlider = x;
    }));

    this.subscription.push(this.sliderModelService.growerOrderHybridAddProductSlider.subscribe(x => {
      this.resetAllSliderValues();
      this.sliderModel.growerOrderHybridAddProductSlider = x;
    }));

  }


  resetAllSliderValues(): void {
    this.sliderModel.appProductAdd = false;
    this.sliderModel.appProductChange = false;
    this.sliderModel.appOrderTransfer = false;
    this.sliderModel.appDealerOrderTransfer = false;
    this.sliderModel.appGrowerSearch = false;
    this.sliderModel.appRetailerSearch = false;
    this.sliderModel.appItemAvailabilityDetail = false;
    this.sliderModel.appdiffDealerGrowerOrderTransfer = false;
    this.sliderModel.appDealerOrderInternalTransfer = false;
    this.sliderModel.growerProgramBudgetSlider = false;
    this.sliderModel.growerProgramNameSlider = false;
    this.sliderModel.growerProgramCommentSlider = false;
    this.sliderModel.reconcileVarietySlider = false;
    this.sliderModel.seedReservationReconcileAddSlider = false;
    this.sliderModel.seedReservationReconcileAddHybridSlider = false;
    this.sliderModel.growerOrderHybridAddProductSlider = false;

  }
  // Loading Year Dropdown
  loadYearDropDown() {
    this.subscription.push(this.dashboard.getCropYear().subscribe(result => {
      this.cropYear = result;
      for (const year in result) {
        if (result[year].active == true) {
          this.selectedYear = result[year].cropYear;
          this.localStorageService.set(MasterConstants.CROP_YEAR_START_DATE, result[year].startDate);
          this.localStorageService.set(MasterConstants.CROP_YEAR_END_DATE, result[year].endDate);
          this.localStorageService.set(MasterConstants.ACTIVE_CROP_YEAR, JSON.stringify(result[year]));
          this.localStorageService.set(MasterConstants.HEADER_CROP_YEAR, JSON.stringify(result[year].cropYear));
          return;
        }
      }
    }, error => LolLoggerService.error(error)));
  }

  // Loading Company Dropdown
  loadCompanyDropDown() {
    this.subscription.push(this.dashboard.getCompanyCode().subscribe(result => {
      // let theme = 'winfield-theme'
      this.company = result;
      this.selectedCompany = MasterConstants.US_COMPANYCODE;
      this.localStorageService.set(MasterConstants.HEADER_COMPANY_CODE, JSON.stringify(MasterConstants.US_COMPANYCODE));

      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      var updatedUser = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany);

      if (updatedUser.isEmulationSet) {
        this.userIdRole = updatedUser.loggedUserRole;
      }
      else {
        this.userIdRole = updatedUser.userIdRole;
      }

      if (this.selectedCompany) {
        this.broadcastService.broadcast(this.configService.ACCESS_TYPE, { accessType: true });
      } else {
        this.enableDisableMenu();
        this.hideShowCOI();
      }

      this.CheckSeedEaStatus(this.validateEvolveData.resultData[0].userMenuAccessList.find(x => x.functionCode == MasterConstants.FUNCTION_CODE.DEALER_ORDERS_TAB && x.accessType.trim().toUpperCase() != 'BLANK'));
    }, error => LolLoggerService.error(error)));
  }

  // Set Seed Early Advantage Access status
  CheckSeedEaStatus(blnDOTAccess) {
    if (blnDOTAccess != undefined) {
      this.subscription.push(this.dealerservice.getDealerEaStatus("EA_US_Allow").subscribe(results => {
        if (results == true) {
          this.localStorageService.set(MasterConstants.SEED_EA_ACCESS, JSON.stringify(true));
        }
        else {
          this.localStorageService.set(MasterConstants.SEED_EA_ACCESS, JSON.stringify(false));
        }
      }, (error => {
        LolLoggerService.error(error);
      })));
    }
    else {
      this.localStorageService.set(MasterConstants.SEED_EA_ACCESS, JSON.stringify(false));
    }
  }
  // to get ProductLine master list
  loadMasterData() {
    this.subscription.push(this.commonService.getMasterData().subscribe((result: any) => {
      // set master data on local storage
      this.localStorageService.set(MasterConstants.MATURITY_MASTER_LIST, JSON.stringify(result.maturityMaster));
      this.localStorageService.set(MasterConstants.MATURITY_LIST, JSON.stringify(result.maturityList));
      this.localStorageService.set(MasterConstants.MARKETING_BRAND_MASTER_LIST, JSON.stringify(result.marketingBrandMaster));
      this.localStorageService.set(MasterConstants.ALL_MARKETING_BRAND_LIST, JSON.stringify(result.allMarketingBrand));
      this.localStorageService.set(MasterConstants.PACKAGE_SIZE_MASTER_LIST, JSON.stringify(result.packageSizeMaster));
      this.localStorageService.set(MasterConstants.ALL_PACKAGE_SIZE_LIST, JSON.stringify(result.allPackageSize));
      this.localStorageService.set(MasterConstants.CPP_PACKAGE_SIZE_LIST, JSON.stringify(result.cppPackageSize));
      this.localStorageService.set(MasterConstants.PRODUCT_LINE_MASTER_LIST, JSON.stringify(result.productLineMaster));
      this.localStorageService.set(MasterConstants.PRODUCT_LINE_MASTER_CPP_LIST, JSON.stringify(result.productLineMasterCPP));
      this.localStorageService.set(MasterConstants.SEED_SIZE_MASTER_LIST, JSON.stringify(result.seedSizeMaster));
      this.localStorageService.set(MasterConstants.ALL_SEED_SIZE_LIST, JSON.stringify(result.allSeedSize));
      this.localStorageService.set(MasterConstants.TECHNOLOGY_MASTER_LIST, JSON.stringify(result.technologyMaster));
      this.localStorageService.set(MasterConstants.TREATMENT_MASTER_LIST, JSON.stringify(result.treatmentMaster));
      this.localStorageService.set(MasterConstants.ALL_TREATMENT_LIST, JSON.stringify(result.allTreatment));
      this.localStorageService.set(MasterConstants.REPORT_PACKAGE_SIZE_MASTER_LIST, JSON.stringify(result.reportPackageSizeMaster));

      this.localStorageService.set(MasterConstants.PRODUCT_CATEGORY_MASTER_LIST, JSON.stringify(result.productCategoryMaster));
      // this.localStorageService.set(MasterConstants.HYBRID_VARIETY_MASTER_LIST, JSON.stringify(result.hybridVarietyMaster));
      this.localStorageService.set(MasterConstants.PRODUCT_SEGMENT_MASTER_LIST, JSON.stringify(result.productSegmentMaster));
      this.localStorageService.set(MasterConstants.FREIGHT_HANDLING_CODE_MASTER_LIST, JSON.stringify(result.freighthandlingCodeMaster));
      this.localStorageService.set(MasterConstants.BRANCH_PLANT_MASTER_LIST, JSON.stringify(result.branchPlantMaster));
      this.localStorageService.set(MasterConstants.PALLET_LINES_MASTER_LIST, JSON.stringify(result.palletLinesMaster));
      this.localStorageService.set(MasterConstants.VERSION_CONTROL_MASTER_LIST, JSON.stringify(result.versionControlMaster));
      this.localStorageService.set(MasterConstants.ORDER_CHANGE_CODE_TYPE_MASTER_LIST, JSON.stringify(result.orderChangeCodeMaster));
      this.localStorageService.set(MasterConstants.CPP_ERROR_CONFIG_MESSAGE, JSON.stringify(result.cppConfigurationMessages));
      this.localStorageService.set(MasterConstants.FREIGHT_INSTRUCTION_MASTER_LIST, JSON.stringify(result.freightInstructionMaster));
      this.localStorageService.set(MasterConstants.ENVIRONMENT, result.environment);
      this.localStorageService.set(MasterConstants.LOG_OFF_TIME, result.logOffTime);
      this.localStorageService.set(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST, JSON.stringify(result.seedReturnItemMaster));
      this.localStorageService.set(MasterConstants.DELIVERY_INSTRUCTIONS_ERROR_MESSAGE, JSON.stringify(result.deliveryInstructionsErrorMessage));
      this.localStorageService.set(MasterConstants.CPP_PRODNAME_SEARCH_OPTIONS, JSON.stringify(result.cppProdNameSearchOptions));
      //this.localStorageService.set(MasterConstants.SEED_PRODNAME_SEARCH_OPTIONS, JSON.stringify(result.seedProdNameSearchOptions));
      this.localStorageService.set(MasterConstants.VENDORNAME_SEARCH_OPTIONS, JSON.stringify(result.vendorNameSearchOptions));
      this.localStorageService.set(MasterConstants.CPP_PRICELIST_PRODNAME_SEARCH_OPTIONS, JSON.stringify(result.cppPriceListProdNameSearchOptions));
      this.localStorageService.set(MasterConstants.APP_VERSION, result.appVersion);

      this.localStorageService.set(MasterConstants.WF_Sales_GenericLevel, JSON.stringify(result.wfSalesGenericLevel));
      this.localStorageService.set(MasterConstants.ENVIRONMENT, result.environment);
      let inoculantCode = result.cppConfigurationMessages.find(x => x.id == "INOCULANT_CODE").value;
      this.localStorageService.set(MasterConstants.PRODUCT_LINE_INOCULANT_CODE, inoculantCode);
      let inoculantCode2 = result.cppConfigurationMessages.find(x => x.id == "INOCULANT_CODE2").value;
      this.localStorageService.set(MasterConstants.PRODUCT_LINE_INOCULANT_CODE2, inoculantCode2);
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (this.validateEvolveData != null && this.validateEvolveData.resultData != null && this.validateEvolveData.resultData.length > 0) {
        let userAccessDetails = this.validateEvolveData.resultData[0];
        if (userAccessDetails.isEmulationSet) {
          window['sendAnalytics'](userAccessDetails.loggedUserId, userAccessDetails.userIdRole);
        }
        else {
          window['sendAnalytics'](userAccessDetails.userId, userAccessDetails.userIdRole);
        }
        this.setUserLoginAnalytics(userAccessDetails);
      }

      if (this.localStorageService.get(MasterConstants.ENVIRONMENT)) {
        this.environmentApply = this.localStorageService.get(MasterConstants.ENVIRONMENT);
      }
    }, error => LolLoggerService.error(error)));
  }

  // load grower program auto save configuration list
  loadGPAutoSaveConfigurations() {
    this.subscription.push(this.commonService.getAutoSaveConfigurations(MasterConstants.GrowerProgramProcessName).subscribe((result: any) => {
      // set grower program auto save configuration  on local storage
      this.localStorageService.set(MasterConstants.GP_AUTO_SAVE_CONFIGURATION, JSON.stringify(result));
    }, error => LolLoggerService.error(error)));
  }

  // Action on Year dropdown value change
  ddlChangeYear(selectedYear) {
    this.localStorageService.set(MasterConstants.HEADER_CROP_YEAR, JSON.stringify(selectedYear.value));
    this.updateCurrentSession(selectedYear.value, this.selectedCompany);
  }

  // Validate number only
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  // Validate Evolve Access
  validateEvolveAccess() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.userSecurityService.validateEvolve().subscribe(results => {
      if (results) {
        // filled data source with API data
        this.validateEvolveData = results;

        if (this.validateEvolveData == null || this.validateEvolveData.resultData == null || this.validateEvolveData.resultData.length == 0) {
          // Need to show error
          this.userAccess = false;
        }
        else {
          this.localStorageService.set(MasterConstants.EVOLVE_ACCESS, JSON.stringify(this.validateEvolveData));
          let activeUser = this.validateEvolveData.resultData[0];
          if (this.selectedCompany) {
            this.broadcastService.broadcast(this.configService.ACCESS_TYPE, { accessType: true });
            activeUser = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany);
          }
          this.chatService.initialize(activeUser);
          if ((activeUser != undefined && activeUser.isSetAccount == true) ||
            (activeUser != undefined && activeUser.evolveAccountRestriction == true && activeUser.evolveSiteAccess == true)) {
            // Load master data
            if (!this.isFromEmualtionPage) {
              this.loadGPAutoSaveConfigurations();
              this.loadMasterData();
              this.loadYearDropDown();
              this.loadCompanyDropDown();
            }
            else if (activeUser.isEmulationSet) {
              this.setUserLoginAnalytics(activeUser);
            }
          }
          else if (activeUser != undefined && activeUser.evolveAccountRestriction == false
            && activeUser.evolveSiteAccess == true && activeUser.isSetAccount == false) {
            // Load master data
            if (!this.isFromEmualtionPage) {
              this.loadMasterData();
              this.loadYearDropDown();
              this.loadCompanyDropDown();
              this.loadGPAutoSaveConfigurations();

              const sessionData = this.validateEvolveData.resultData[0];
              if (sessionData.evolveAccountRestriction == false) {
                if (this.userSecurityAccess.isCommandCenterAccess) {
                  this.router.navigate(['/cc/landing-data']);
                } else {
                  this.router.navigate(['/account']);
                }

              }
              else {
                // Need to show error
                this.userAccess = false;
              }
            }
            else if (activeUser.isEmulationSet) {
              this.setUserLoginAnalytics(activeUser);
            }
          }
          this.isPageLoad = true;

        }
      }
      else {
        // Need to show error
        this.userAccess = false;
        this.isPageLoad = true;
      }
      this.loaderService.setLoaderStatus(false);
    }
      , (error => {
        this.loaderService.setLoaderStatus(false);
        LolLoggerService.info(error);
        this.isPageLoad = true;
      })
    ));
  }

  // Update Current Session
  updateCurrentSession(cropYear: string, companyCode: string) {
    this.subscription.push(this.dashboard.updateCurrentSession(cropYear, companyCode).subscribe(result => {
    }, error => LolLoggerService.error(error)));
  }

  // Show/hide logout button
  showHidelogOut() {
    this.showLogout = !this.showLogout;
  }

  // Company and Year Section for Small Resolution
  showHideCompanyYear() {
    if (!this.isCompanyYearVisible) {
      this.showCompanyYear = !this.showCompanyYear;
    }
  }

  // Close Company Year form when tapped outside code for Small Resolution
  closeCompanyYear() {
    if (this.isCompanyYearVisible) {
      this.isCompanyYearVisible = false;
    } else {
      this.showCompanyYear = false;
    }
  }

  // Close user profile when tapped outside code for Small Resolution
  closeUserProfile() {
    if (this.isUserGreetingsVisible) {
      this.isUserGreetingsVisible = false;
    } else {
      this.showUserProfile = false;
    }
  }

  // Show User Profile for small Resolution
  showHideUserProfile() {
    this.showUserProfile = !this.showUserProfile;
    if (!this.isUserGreetingsVisible) {
      this.isUserGreetingsVisible = true;
    }
  }

  // Logout
  logOut() {
    this.showLogout = false;
    this.isSignOut = true;
    this.cookieService.deleteAllCookies();
    this.router.navigate(['/logout']);
  }

  // openDialog
  openDialog() {
    const customerEmail = 'WinFieldCustomerService@landolakes.com';
    var env = this.environmentApply;
    if (env != 'PROD') {
      env = '-' + env;
    }
    else {
      env = '';
    }
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        title: 'Need help? Reach out' + env,
        content: `<p>Phone: <a href="tel:1-855-494-6343">1-855-494-6343</a></p>
              <p>Email: <a href="mailto:${customerEmail}">${customerEmail}</a></p>
              <p>App Version: ${this.localStorageService.get(MasterConstants.APP_VERSION)}`
      }
    });

    dialogRef.afterClosed().subscribe(r => {
      //console.log(this.configPath);
      if (this.configPath == '/common/get-user') {
        const authData = 'EvolveConfig'
        this.subscription.push(this.networkService.getRequest('api/common/get-user' + '?auth=' + authData).subscribe(result => {
          console.log('API result - ', result);
        }));
      }
    });
  }

  enableDisableMenu() {
    const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    //reset security access
    this.userSecurityAccess = new UserSecurityAccess();

    const emulationdata = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany);

    if (evolveAccessData) {
      this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany).userMenuAccessList;
      const sotAccess = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany).isSOTAccess;
      const isUserEmulation = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany).isUserEmulation;
      const sraAccess = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany).isSRAAccess;
      this.sraOrderAccess = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany).isSraOrderAccess;
      this.sraApproversAccess = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany).isSraApproversAccess;
      const edlpAccess = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany).isEDLPAccess;
      const associateReconsileAccess = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany).associateReconciliationAccess;
      const associateInventoryAccess = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany).associateInventoryAccess;
      if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.COMMAND_CENTER)) {
          this.userSecurityAccess.isCommandCenterAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.GROWER_ORDERS_TAB) ||
          this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.DEALER_ORDERS_TAB)) {
          this.userSecurityAccess.isOrderAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.DEALER_ORDERS_TAB)) {
          this.userSecurityAccess.isDealerOrderAccess = true;
        }

        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.ORDER_TO_INVOICE)) {
          this.userSecurityAccess.isOTIAccess = true;
        }

        if (emulationdata.isEmulationSet &&
          (isUserEmulation || emulationdata.isEmulationOverrideByUserID) &&
          this.commonService.checkUserRoleAccessTypeForMenu(emulationdata.loginUserMenuAccessList, MasterConstants.FUNCTION_CODE.ACCOUNTS_TAB)) {
          this.userSecurityAccess.isAccountAccess = true;
        }
        else if (!emulationdata.isEmulationSet && this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.ACCOUNTS_TAB)) {
          this.userSecurityAccess.isAccountAccess = true;
        }

        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.FULFILLMENT_TAB)) {
          this.userSecurityAccess.isFulfillmentAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.QUICK_ORDER_REPORT)) {
          this.userSecurityAccess.isQosSearchAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.PRODUCT_AVAILABILITY_REPORT)) {
          this.userSecurityAccess.isPAvailabilityAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.DEALER_AUDIT_REPORT)) {
          this.userSecurityAccess.isDOAuditAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.GROWER_AUDIT_REPORT)) {
          this.userSecurityAccess.isGOAuditAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.TOTAL_ORDER_SUMMARY)) {
          this.userSecurityAccess.isTOSAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.SHIPPABLE_PRODUCTS_REPORT)) {
          this.userSecurityAccess.isShippableProducts = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.SUBSTITUTION_ORDER_REPORT)) {
          this.userSecurityAccess.isSubstitutionOrderReport = true;
        }

        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.FULFILLMENT_SHIPPING_AVAILABILITY_REPORT)) {
          this.userSecurityAccess.isShippingAvailabilityReport = true;
        }

        if (emulationdata.isEmulationSet &&
          (emulationdata.isUserEmulation || emulationdata.isEmulationOverrideByUserID) &&
          this.commonService.checkUserRoleAccessTypeForMenu(emulationdata.loginUserMenuAccessList, MasterConstants.FUNCTION_CODE.EMULATION_DASHBOARD)) {
          this.userSecurityAccess.isEmulationAccess = true;
        }
        else if (!emulationdata.isEmulationSet &&
          (isUserEmulation || emulationdata.isEmulationOverrideByUserID) &&
          this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.EMULATION_DASHBOARD)) {
          this.userSecurityAccess.isEmulationAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.PREPAY)) {
          this.userSecurityAccess.isPrepayAccess = true;
        }

        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_ORDER)) {
          this.userSecurityAccess.isCPPOrderAccess = true;
          this.userSecurityAccess.isCPPDeliveryInstructionAccess = true;
        }

        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.MARKETING_PROGRAM_SUMMARY)) {
          this.userSecurityAccess.isMarketingProgramAccess = true;
        }

        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_ERROR_ORDER_MAINTENANCE)) {
          this.userSecurityAccess.isCPPErrorAccess = true;
        }

        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST)) {
          this.userSecurityAccess.isCPPPriceListAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CPP_USER_LIST)) {
          this.userSecurityAccess.isCPPUserListAccess = true;
        }

        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.LICENSE_EVOLVE)) {
          this.userSecurityAccess.isLicenseAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.PARTNER_WEBSITE)) {
          this.userSecurityAccess.partnerAccessTypeMode = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.RETURN_REQUEST_INVENTORY_PROTECTION)) {
          this.userSecurityAccess.isSeedReturnAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.RETURN_REQUEST_IP_APPROVAL)) {
          this.userSecurityAccess.isSeedReturnAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS)) {
          this.userSecurityAccess.isCPPProductReturnsAccess = true;
          this.userSecurityAccess.isCPPContainerReturnsAccess = true;
        }

        // For CPP Forecast Manager with IFQ Access Only
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.SEED_REPLANT)) {
          this.userSecurityAccess.isSeedReplantAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.SEED_REPLANT_APPROVAL)) {
          this.userSecurityAccess.isSeedReplantAccess = true;
        }

        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.SOT_STOCK_TRANSFERS) && sotAccess == true) {
          this.userSecurityAccess.isSOTStockTransferAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.SEED_RESERVATION)) {
          this.userSecurityAccess.isSeedReservationAccess = true;
        }

        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_ASSOCIATES)) {
          this.userSecurityAccess.isSeedCropAssociatesAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.PLOT_SEED)) {
          this.userSecurityAccess.isPlotSeedAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.PLOT_SEED_RELEASE)) {
          this.userSecurityAccess.isPlotSeedReleaseAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.AI_VIRTUAL_ASSISTANT)) {
          this.userSecurityAccess.isVirtualAssistantAccess = true;
        }
        if (!this.userSecurityAccess.isVirtualAssistantAccess) {
          this.showChatbot = false;
        }

        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.DELIVERY_INSTRUCTIONS)) {
          this.userSecurityAccess.isDeliveryInstructionsAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.SRA_ORDERS) && this.sraOrderAccess) {
          this.userSecurityAccess.isSRAOrderAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.SRA_APPROVERS) && this.sraApproversAccess) {
          this.userSecurityAccess.isSraApproversAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.PROVING_GROUND_SEED_ORDER)) {
          this.userSecurityAccess.isProvingGroundSeedAccess = true;
        } 
        if (this.selectedCompany == MasterConstants.US_COMPANYCODE && emulationdata.isRoleHierarchySetup) {
          this.userSecurityAccess.issubscriptionMgtAccess = true;
        }

        if (this.userSecurityAccess.isCPPPriceListAccess == true && sraAccess == true) {
          this.userSecurityAccess.isSRAAccess = true;
        }

        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_ASSOCIATES_RECONCILIATION) && associateReconsileAccess) {
          this.userSecurityAccess.isAssociateRenconciliationAccess = true;
        }
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_ASSOCIATES_INVENTORY) && associateInventoryAccess) {
          this.userSecurityAccess.isAssociateInventoryAccess = true;
        }

        //Manage the Report Menu in CPP
        if (this.userSecurityAccess.isSRAAccess || this.userSecurityAccess.isCPPPriceListAccess || edlpAccess) {
          this.userSecurityAccess.isCPPReportAccess = true;
        }
        if (edlpAccess && this.userSecurityAccess.isCPPPriceListAccess) {
          this.userSecurityAccess.isEDLPAccess = true;
        }
        if (this.userSecurityAccess.isCPPProductReturnsAccess || this.userSecurityAccess.isCPPContainerReturnsAccess) {
          this.userSecurityAccess.isCPPReturnsAccess = true;
        }

        // Manage the CPP Menu
        if (this.userSecurityAccess.isCPPOrderAccess || this.userSecurityAccess.isCPPErrorAccess || this.userSecurityAccess.isCPPPriceListAccess
          || this.userSecurityAccess.isCPPReturnsAccess || this.userSecurityAccess.isCPPReportAccess || this.userSecurityAccess.isMarketingProgramAccess || this.userSecurityAccess.isSRAOrderAccess || this.userSecurityAccess.isSraApproversAccess || this.userSecurityAccess.isCPPUserListAccess) {
          this.userSecurityAccess.isCPPtabAccess = true;
          this.cppPriceAccounts = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany).cppPriceAccount;
        }

        //Manage Grower Programs Menu
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.GROWER_PROGRAMS)) {
          this.userSecurityAccess.isGrowerProgramsAccess = true;
        }

        //Manage Grower Programs Seed Dashboard Menu
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.GROWER_PROGRAMS_SEED)) {
          this.userSecurityAccess.isSeedDiscretionaryAccess = true;
        }

        if (this.userSecurityAccess.isQosSearchAccess
          || this.userSecurityAccess.isPAvailabilityAccess
          || this.userSecurityAccess.isDOAuditAccess
          || this.userSecurityAccess.isGOAuditAccess
          || this.userSecurityAccess.isTOSAccess
          || this.userSecurityAccess.isShippableProducts
          || this.userSecurityAccess.isSubstitutionOrderReport
          || this.userSecurityAccess.isShippingAvailabilityReport) {
          this.userSecurityAccess.isReportAccess = true;
        }

        if (this.userSecurityAccess.isOrderAccess
          || this.userSecurityAccess.isFulfillmentAccess
          || this.userSecurityAccess.isReportAccess
          || this.userSecurityAccess.isLicenseAccess
          || this.userSecurityAccess.isSeedReturnAccess
          || this.userSecurityAccess.isSeedReplantAccess
          || this.userSecurityAccess.isSOTStockTransferAccess
          || this.userSecurityAccess.isSeedReservationAccess
          || this.userSecurityAccess.isSeedCropAssociatesAccess
          || this.userSecurityAccess.isAssociateRenconciliationAccess
          || this.userSecurityAccess.isAssociateInventoryAccess
          || this.userSecurityAccess.isPlotSeedAccess
          || this.userSecurityAccess.isPlotSeedReleaseAccess
          || this.userSecurityAccess.isProvingGroundSeedAccess) {
          this.userSecurityAccess.isSeedAccess = true;
        }
      }

      if (emulationdata.isEmulationSet) {
        this.userId = emulationdata.loggedUserId;
        this.firstName = emulationdata.firstName;
        this.lastName = emulationdata.lastName;
        this.isEmulated = true;
        this.emulatedUserId = emulationdata.userId + ' [' + emulationdata.userIdRole + ']';
      }
      else {
        this.userId = emulationdata.userId;
        this.firstName = emulationdata.firstName;
        this.lastName = emulationdata.lastName;
        this.isEmulated = false;
        this.emulatedUserId = '';
      }
      if (this.isFromEmualtionPage) {
        this.broadcastService.broadcast(this.configService.SET_USER_EMULATION, { setUserEmulation: true });
      }
    }

    if (this.isRedirectPage) {
      this.isRedirectPage = false;
    } else {
      this.redirectToPage();
    }
  }

  redirectToPage() {
    if (this.isMobile) {
      this.redirectToHomePageForMobile();
      return;
    }

    if (this.selectedCompany !== MasterConstants.US_COMPANYCODE) {
      return;
    }

    if (this.userSecurityAccess.isCommandCenterAccess) {
      let path = localStorage.getItem('url-path');
      if ((path === undefined || path === null) && location.pathname.indexOf('cc/landing-data') === -1) {
        path = location.pathname;
        localStorage.setItem('url-path', path);
      }
      if (path && path.indexOf("unauthorize") === -1) {
        this.router.navigateByUrl(path);
      } else {
        this.router.navigate(['/cc/landing-data']);
      }
      return;
    }

    const navigationPaths = [
      { access: this.userSecurityAccess.isCommandCenterAccess, path: '/cc/landing-data' },
      { access: this.userSecurityAccess.isOrderAccess, path: '/order/dashboard' },
      { access: this.userSecurityAccess.isSRAOrderAccess && this.sraOrderAccess, path: '/cpp/orders/sra-order-landing' },
      { access: this.userSecurityAccess.isSraApproversAccess && this.sraApproversAccess, path: '/sro/error/order-maintenance-dashboard' },
      { access: this.userSecurityAccess.isFulfillmentAccess, path: '/seed-fulfillment' },
      { access: this.userSecurityAccess.isDeliveryInstructionsAccess, path: '/delivery-instructions' },
      { access: this.userSecurityAccess.isReportAccess, path: this.getReportPath() },
      { access: this.userSecurityAccess.isLicenseAccess, path: '/licenses' },
      { access: this.userSecurityAccess.isSeedReturnAccess, path: '/seed-return-dashboard' },
      { access: this.userSecurityAccess.isSeedReplantAccess, path: '/seed-replant-landing' },
      { access: this.userSecurityAccess.isSOTStockTransferAccess, path: '/sot-landing' },
      { access: this.userSecurityAccess.isCPPOrderAccess, path: '/cpp/landing-data' },
      { access: this.userSecurityAccess.isCPPErrorAccess, path: '/cpp/error-order-maintenance-dashboard' },
      { access: this.userSecurityAccess.isCPPPriceListAccess, path: this.getCPPPriceListPath() },
      { access: this.userSecurityAccess.isCPPReportAccess, path: this.userSecurityAccess.isSRAAccess ? '/cpp/sra-cost-sheet-retail' : '' },
      { access: this.userSecurityAccess.isCPPReturnsAccess, path: '/cpp-returns/dashboard-products' },
      { access: this.userSecurityAccess.isCPPCOIAccess, path: '/cpp/cpp-coi-landing' },
      { access: this.userSecurityAccess.isAccountAccess, path: '/account' },
      { access: this.userSecurityAccess.isEmulationAccess, path: '/emulation' },
      { access: this.userSecurityAccess.isPrepayAccess, path: '/prepay' },
      { access: this.userSecurityAccess.isCPPDeliveryInstructionAccess, path: '/cpp/cpp-delivery-instructions' },
      { access: this.userSecurityAccess.isSeedReservationAccess, path: '/seed-reservation-landing' },
      { access: this.userSecurityAccess.isCPPUserListAccess, path: '/cpp/cpp-user-list' },
      { access: this.userSecurityAccess.isSeedCropAssociatesAccess, path: '/associate-crop-landing' },
      { access: this.userSecurityAccess.isPlotSeedAccess, path: '/plot-seed-landing' },
      { access: this.userSecurityAccess.isPlotSeedReleaseAccess, path: '/plot-seed/plot-seed-release-landing' },
      { access: this.userSecurityAccess.isProvingGroundSeedAccess, path: '/proving-ground-seed-landing' }
    ];

    const route = navigationPaths.find(route => route.access);
    if (route) {
      this.router.navigate([route.path]);
    } else {
      this.router.navigate(['/unauthorize']);
    }
  }

  private getReportPath(): string {
    if (this.userSecurityAccess.isQosSearchAccess) return '/reports/order-detail-report';
    if (this.userSecurityAccess.isPAvailabilityAccess) return '/reports/product-availability-report';
    if (this.userSecurityAccess.isDOAuditAccess) return '/reports/dealer-order-audit';
    if (this.userSecurityAccess.isGOAuditAccess) return '/reports/grower-order-audit';
    if (this.userSecurityAccess.isTOSAccess) return '/reports/total-order-summary';
    if (this.userSecurityAccess.isShippableProducts) return '/reports/shippable-products-report';
    if (this.userSecurityAccess.isSubstitutionOrderReport) return '/reports/substitution-order-report';
    if (this.userSecurityAccess.isShippingAvailabilityReport) return '/reports/shipping-availability-report';
    return '';
  }

  private getCPPPriceListPath(): string {
    if (this.cppPriceAccounts && this.cppPriceAccounts.length === 1) {
      this.cppPriceListService.accountName = this.cppPriceAccounts[0].accountName;
      const accountNumber = this.cppPriceAccounts[0].accountNumber;
      return `/cpp/price-list-dashboard/${accountNumber}`;
    }
    return '/cpp/customer-price-list';
  }

  redirectToCPPProductsOrPrice() {
    this.loaderService.setLoaderStatus(true);
    if (this.cppPriceAccounts && this.cppPriceAccounts.length === 1) {
      this.cppPriceListService.accountName = this.cppPriceAccounts[0].accountName;
      const accountNumber = this.cppPriceAccounts[0].accountNumber;
      this.router.navigate(['/cpp/price-list-dashboard/' + accountNumber]);
    } else {
      this.router.navigate(['/cpp/customer-price-list']);
    }

    this.loaderService.setLoaderStatus(false);

  }

  redirectToPricingLookup() {
    this.loaderService.setLoaderStatus(true);
    let accounts = this.cppPriceAccounts.filter(x => x.accountType?.toLowerCase() != "pl" || x.accountNumber === MasterConstants.UsNationalAccount);
    if (accounts && accounts.length === 1) {
      this.cppPriceListService.accountName = accounts[0].accountName;
      const accountNumber = accounts[0].accountNumber;
      this.router.navigate(['/pricelistLookup/cpp-price-list-lookup-grid/' + accountNumber]);
    } else {
      this.router.navigate(['/pricelistLookup/customer-price-list/']);
    }

    this.loaderService.setLoaderStatus(false);

  }

  SaveloginTime() {
    if (typeof (Storage) !== 'undefined') {
      localStorage.setItem('loginTime', new Date().getTime().toString());
    }
  }

  // check logged out every minute
  CheckLoggedOut() {
    let check = true;
    const that = this;
    setInterval(function () {
      if (that.IsTokenExpired()) {
        that.Reauthenticate();
      }
      const loginTime = localStorage.getItem('loginTime');
      let loggOffTime = localStorage.getItem(MasterConstants.LOG_OFF_TIME);
      if (loginTime === null) {
        check = false;
      }
      if (check && typeof (Storage) !== 'undefined') {
        const currentTime = new Date().getTime();
        loggOffTime = loggOffTime ?? '0';
        // logout after n minutes of login as per the appSetting.
        if (((currentTime - +loginTime)) > (60 * +loggOffTime * 1000)) {
          that.openTimeOutDialog();
          const btn = document.getElementById('dialog-close'); // Find the close button of popup
          // refresh base url to login
          btn.onclick = function () { that.redirectToLoginPage() }; // Add onclick event to reload
          check = false;
          //}
        }
      }
    }, 1000 * 60); // 60 * 1000 milsec
  }

  IsTokenExpired() {
    let currentTimeinSeconds = Math.floor(new Date().getTime() / 1000);
    const useLoggedintime: any = localStorage.getItem('loggedInTimeSecond');
    const tokenExpiry: any = localStorage.getItem('tokenExpiry');
    let timeElapsed = currentTimeinSeconds - useLoggedintime;
    if (timeElapsed >= tokenExpiry) {
      return true;
    }
    return false;
  }

  Reauthenticate() {
    const refreshToken: string = localStorage.getItem('refreshToken');
    this.subscription.push(this.authenticationSerivce.getAuthTokenByRefreshToken(refreshToken).subscribe(results => {
      if (results && results.message == "Token Expired") {
        this.loaderService.setLoaderStatus(false);
        this.ClearToken();
      }
      else if (results) {
        this.localStorageService.set('token', results.access_token);
        this.localStorageService.set('refreshToken', results.refresh_token);
        this.localStorageService.set('tokenExpiry', results.expires_in);
        this.localStorageService.set('loggedInTimeSecond', Math.floor(new Date().getTime() / 1000));
      }
    }, (error => {
      this.loaderService.setLoaderStatus(false);
      this.ClearToken();
    })));
  }

  private ClearToken() {
    this.localStorageService.remove('token');
    this.localStorageService.remove('refreshToken');
    this.localStorageService.remove('tokenExpiry');
    this.ngOnInit();
  }

  openTimeOutDialog() {
    this.dialog.open(DialogComponent, {
      disableClose: true,
      width: '500px',
      panelClass: 'logoutModal',
      data: {
        title: 'Logged Out',
        content: '<p>Your session has been expired due to inactivity. Your page will be refreshed.</p>'
      }
    });
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.emulationChangeSubscription) {
      this.emulationChangeSubscription.unsubscribe();
      this.isFromEmualtionPage = false;
      this.isRedirectPage = false;
    }

    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // Get Partner website data
  getPartnerWebsiteData() {
    this.loaderService.setLoaderStatus(true);
    this.dashboardFilter.shipToAccount = 0;
    this.subscription.push(this.dashboard.getPartnerWebsite(this.dashboardFilter).subscribe(result => {
      this.partnerURLs = result;
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    })));
  }

  // On Navigate
  onNavigate(type) {
    if (type == 'bayerevolve') {
      window.open(this.partnerURLs.bayerEvolve, '_blank');
    }
    else if (type == 'mycrop') {
      window.open(this.partnerURLs.myCrop, '_blank');
    }
    else if (type == 'seedware-phytogen') {
      window.open(this.partnerURLs.seedwarePhytogenUrl, '_blank');
    }
    else if (type == 'seedware-brevant') {
      window.open(this.partnerURLs.seedwareUrl, '_blank');
    }
  }

  // Business Rule Analysis pop-up Dialog display
  OpenAccountListWindow() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    this.matDialog.open(CropEdgeAccountListDialogComponent, dialogConfig);
  }

  // Home Page redirection for Mobile Device
  redirectToHomePageForMobile() {
    if (this.userSecurityAccess.isCPPOrderAccess) {
      // CPP Order
      this.router.navigate(['/cpp/landing-data']);
    }
    else if (!this.userSecurityAccess.isCPPOrderAccess && this.userSecurityAccess.isSeedAccess) {
      // CPP Order
      this.router.navigate(['/landing-data']);
    }
    else {
      // Unauthorize user access on mobile
      this.router.navigate(['/unauthorize']);
    }
  }

  // Hide/Show the Menu
  hideShowCOI() {
    const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    this.userSecurityAccess.isCPPCOIAccess = false;

    if (evolveAccessData) {
      this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany).userMenuAccessList;
      if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.COI_ORDER)) {
          this.subscription.push(this.commonService.checkCoiAccess().subscribe(result => {
            if (result == true) {
              this.userSecurityAccess.isCPPCOIAccess = true;
            }

            if (this.userSecurityAccess.isCPPOrderAccess || this.userSecurityAccess.isCPPErrorAccess || this.userSecurityAccess.isCPPPriceListAccess
              || this.userSecurityAccess.isCPPReturnsAccess ||
              this.userSecurityAccess.isCPPCOIAccess || this.userSecurityAccess.isCPPDeliveryInstructionAccess || this.userSecurityAccess.isCPPUserListAccess) {
              this.userSecurityAccess.isCPPtabAccess = true;
              this.cppPriceAccounts = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.selectedCompany).cppPriceAccount;
            } else {
              this.userSecurityAccess.isCPPtabAccess = false;
            }

            this.loaderService.setLoaderStatus(false);
          }, (error => {
            LolLoggerService.error(error);
            this.loaderService.setLoaderStatus(false);
          })));
        }
      }
    }
  }

  ondistanceCall() {
    LolLoggerService.info('ondistanceCall');
    this.subscription.push(this.dashboard.GetApiDistance().subscribe(results => {
      if (results) {
        alert('Success:' + results);
        LolLoggerService.info('Success:' + results);
      }
    }, error => {
      alert('Error' + error);
      LolLoggerService.error('Error' + error);
    }));
  }

  // Click Subscription Management
  clickSubscriptionManagement() {
    this.router.navigate(['/subscription-landing-page']);
  }

  redirectToLoginPage() {
    let urlRef = '';
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.authenticationSerivce.getOAuthSettings(urlRef).subscribe(response => {
      if (response) {
        let url = `${response.oAuthEndSessionURL}?TargetResource=${response.redirectURI}`;
        window.location.href = url;
      }
    }, (error => {
      this.loaderService.setLoaderStatus(false);
      LolLoggerService.info('Failed To Get OAuthSettings');
      LolLoggerService.error(error);
    })));
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (this.loaderService.showLoader.value) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
